export default __webpack_public_path__ + "static/media/box-solid-white.cf58b43c.svg";